import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeBE } from "../const";

export const CDMS_STUDY_IP_CODE: {
  CDMS_STUDY_IP_CODE_VALID_NOT_FOUND: MvnCodeBE;
  CDMS_STUDY_IP_CODE_ALREADY_EXISTED_AMOUNT_ITEM: MvnCodeBE;
  CDMS_STUDY_IP_CODE_AMOUNT_ITEM_NOT_A_NUMBER: MvnCodeBE;
  CDMS_STUDY_IP_CODE_EXCEEDS_ROW_COUNT: MvnCodeBE;
  CDMS_STUDY_IP_CODE_AMOUNT_ITEM_NOT_FOUND: MvnCodeBE;
  CDMS_STUDY_IP_CODE_RETRIEVE_UNEXPECTED_IP_CODE_EXIST: MvnCodeBE;
} = {
  CDMS_STUDY_IP_CODE_VALID_NOT_FOUND: {
    status: 404,
    ko: "유효한 IP를 찾을 수 없습니다.",
    en: "Valid IP allocation not found.",
  },
  CDMS_STUDY_IP_CODE_ALREADY_EXISTED_AMOUNT_ITEM: {
    status: 409,
    ko: "이미 캡처한 수량 아이템입니다.",
    en: "Amount Item has already been captured.",
  },
  CDMS_STUDY_IP_CODE_AMOUNT_ITEM_NOT_A_NUMBER: {
    status: 400,
    ko: "수량 아이템을 숫자로 입력하세요.",
    en: "Amount Item must be a number.",
  },
  CDMS_STUDY_IP_CODE_EXCEEDS_ROW_COUNT: {
    status: 400,
    ko: "IP Code 개수가 행의 개수를 초과합니다.",
    en: "The number of IP Codes to be captured exceeds the number of rows.",
  },
  CDMS_STUDY_IP_CODE_AMOUNT_ITEM_NOT_FOUND: {
    status: 404,
    ko: "저장된 Amount Item이 없습니다.",
    en: "Amount Items needs to be saved to assign an IP Code.",
  },
  CDMS_STUDY_IP_CODE_RETRIEVE_UNEXPECTED_IP_CODE_EXIST: {
    status: 409,
    ko: "오불출을 선택하지 않았음에도 IP Code 값이 존재합니다.",
    en: "IP Code exists even though Misdispense is not checked.",
  },
};

MvnCodeInitiate(CDMS_STUDY_IP_CODE);
